"use client";
import React from "react";
import { usePathname } from "next/navigation";

export const SocialShare = () => {
  const pathname = usePathname();
  const fullUrl = encodeURIComponent(`${process.env.NEXT_PUBLIC_SITE_URL}${pathname}`);
  
  const shareLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`,
    twitter: `https://twitter.com/intent/tweet?url=${fullUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${fullUrl}`,
    whatsapp: `https://wa.me/?text=${fullUrl}`,
    youtube: "https://www.youtube.com",
    instagram: "https://www.instagram.com",
  };

  return (
    <div className="flex items-center gap-2.5">
      <a
        href={shareLinks.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#1877F2] flex items-center justify-center text-gray-600 hover:text-white transition-all duration-300"
      >
        <i className="ri-facebook-fill text-xl"></i>
      </a>
      <a
        href={shareLinks.twitter}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#1DA1F2] flex items-center justify-center text-gray-600 hover:text-white transition-all duration-300"
      >
        <i className="ri-twitter-fill text-xl"></i>
      </a>
      <a
        href={shareLinks.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#0077B5] flex items-center justify-center text-gray-600 hover:text-white transition-all duration-300"
      >
        <i className="ri-linkedin-fill text-xl"></i>
      </a>
      <a
        href={shareLinks.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#25D366] flex items-center justify-center text-gray-600 hover:text-white transition-all duration-300"
      >
        <i className="ri-whatsapp-fill text-xl"></i>
      </a>
      <a
        href={shareLinks.youtube}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#FF0000] flex items-center justify-center text-gray-600 hover:text-white transition-all duration-300"
      >
        <i className="ri-youtube-fill text-xl"></i>
      </a>
      <a
        href={shareLinks.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className="w-10 h-10 rounded-full bg-gray-200 hover:bg-gradient-to-r hover:from-[#833AB4] hover:via-[#FD1D1D] hover:to-[#FCAF45] flex items-center justify-center text-gray-600 hover:text-white transition-all duration-300"
      >
        <i className="ri-instagram-line text-xl"></i>
      </a>
    </div>
  );
};
